import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from '@internal/ui-kit/lib/sentry.ts'
import { installBootFailureRecovery } from '@internal/ui-kit/lib/bootRecovery.ts'
import { installChunkLoadRecovery } from '@internal/ui-kit/lib/chunkLoadRecovery.ts'

initSentry()

const { markBooted } = installBootFailureRecovery()
installChunkLoadRecovery()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

markBooted()
